module.exports = __webpack_public_path__ + "media/images/light_error_icon-453a3a32411b0b3c62f6880214a8dcfb.svg";